import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { securityApi, type SecurityPolicy } from '../../api/security';

export function PolicyManagerPage() {
  const [policies, setPolicies] = useState<SecurityPolicy[]>([]);
  useEffect(() => { void securityApi.policies().then(setPolicies); }, []);
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Policy Manager</h1>
      <Link to="/security" className="mt-2 inline-block text-sm text-indigo-700 hover:underline dark:text-indigo-400">← SOC Hub</Link>
      <div className="mt-6 space-y-3">{policies.map((p) => (
        <div key={p.id} className="rounded-xl border p-4 dark:border-slate-700">
          <p className="font-medium">{p.name}</p>
          <p className="text-sm text-slate-500">{p.type} · {p.effect} · {p.active ? 'Active' : 'Inactive'}</p>
          {p.conditions && <ul className="mt-2 list-disc pl-5 text-xs text-slate-500">{p.conditions.map((c, i) => <li key={i}>{c}</li>)}</ul>}
        </div>
      ))}</div>
    </div>
  );
}
